import { graphql, useStaticQuery } from "gatsby"

const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          description
          keywords
          title
        }
      }
    }
  `)

  return data.site.siteMetadata
}

export default useSiteMetadata
